import { createApp } from 'vue'
import OverlayLeadGate from './OverlayLeadGate.vue'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'
import { useMainStore } from 'stores/main.store'

const el = '.be-component--overlay-lead-gate'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((OverlayLeadGateDOM) => {
            
            const props = handleComponentProps(OverlayLeadGate, OverlayLeadGateDOM)

            const component = createApp(OverlayLeadGate, props).use(Store)
            const mainStore = useMainStore()
            mainStore.setLeadGateData({ guid: props.guid })
            // component.mount(OverlayLeadGateDOM)
        })
    }
}